/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import { isEmpty } from '../../utils/lodashExtend';
import systemAlert from '../../utils/systemAlert';
import { sendAlert } from '../../apis/counseling/counseling';
import { toast } from '../../utils/toast';

const SendEmailForm = ({ open, setOpen, params }) => {
  const [fields] = useState([{
    title: "이메일",
    key: "email",
    type: "input",
    required: true,
    validators: ['email']
  }]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
  };


  const _submit = (form) => {

    const sendParams = {
      ...params,
      ...form
    };

    systemAlert(`${form.email}에 알람메일을 발송하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            sendAlert(sendParams)
              .then(() => {
                toast.success("발송요청이 완료되었습니다.");
                cancel();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  useEffect(() => {
    !isEmpty(params) && setForm(params);
  }, [params]);

  useEffect(() => {
    if (!isEmpty(fields)) {
      setValidateFields(fields);
    }
  }, [fields]);

  const {
    form,
    setForm,
    errors,
    setValidateFields,
    handleOnChange,
    handleSubmit,
  } = useForm(
    params,
    _submit,
  );

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>이메일 전송하기</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"메일전송"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default SendEmailForm;